import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-product-roadmap',
  templateUrl: './product-roadmap.component.html',
  styleUrls: ['./product-roadmap.component.scss']
})
export class ProductRoadmapComponent implements OnInit {
  constructor(private titleService: Title) {}

  ngOnInit() {
    this.titleService.setTitle('Product Roadmap | Kahi');
  }
} 